export default __webpack_public_path__ + "static/media/carosello5.d45bd329.png";